import React, { PureComponent } from "react";
import { withRouter } from "react-router";
import Service from "@base/service";
import Playlist from "@components/Playlist";
import "./Playlist.less";

class PlaylistPage extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      playlist: null,
    };
    this.service = new Service();
  }

  render() {
    if (!this.state.playlist) return null;
    return (
      <div className="Playlist-page">
        <Playlist
          scroll={false}
          id={this.state.playlist.id}
          titulo={this.state.playlist.title}
          videos={this.state.playlist.videos}
        />
      </div>
    );
  }

  async componentDidMount() {
    const radio = await this.service.getRadio();
    const id = this.props.match.params.id;
    const playlists = radio.playlists.filter(
      (playlist) => playlist.id.toString() === id
    );
    if (typeof playlists[0] !== "undefined") {
      this.setState({
        playlist: playlists[0],
      });
    }
  }
}

export default withRouter(PlaylistPage);
